import { useTranslation } from 'react-i18next'

import { useSendPasswordReset, useSendSetupLink } from '@/api/account'
import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils/error'

export const useAccountEmailActions = () => {
  const { t } = useTranslation(['organisation'])
  const { isPending: isSendingSetupLink, mutateAsync: sendSetupLink } = useSendSetupLink()
  const { isPending: isSendingPasswordReset, mutateAsync: sendPasswordReset } =
    useSendPasswordReset()

  const handleSendSetupLink = async (email: string) => {
    try {
      await sendSetupLink(email)
      toastFactory.success(t('organisation:shared.accountEmails.setupLinkSent', { email }))
    } catch (error) {
      toastFactory.error(getApiErrorMessage(error))
    }
  }

  const handleSendPasswordReset = async (email: string) => {
    try {
      await sendPasswordReset(email)
      toastFactory.success(t('organisation:shared.accountEmails.passwordResetSent', { email }))
    } catch (error) {
      toastFactory.error(getApiErrorMessage(error))
    }
  }

  return {
    handleSendPasswordReset,
    handleSendSetupLink,
    isSendingPasswordReset,
    isSendingSetupLink,
  }
}
